<template>
  <div @click="forceSplashClosed" class="d-flex align-items-center justify-content-center vh-100 w-100">
    <transition
        appear
        @before-enter="beforeEnter"
        @enter="enter"
        :css="false"
    >
      <div class="mb-5">
        <Logo></Logo>
      </div>
    </transition>
    <div v-if="loadingFailed" style="position:absolute; bottom: 32px;" class="text-muted-more">
      {{ $t('SplashScreen.connectingToServer') }}
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import Logo from '@shared/components/Logo'
import AppInitializationMixin from '@shared/mixins/AppInitializationMixin'
import settings from '@shared/settings'

export default {
  name: 'SplashScreen',
  components: { Logo },
  mixins: [AppInitializationMixin],
  data() {
    return {
      initialized: false,
      loadingFailed: false
    }
  },
  mounted() {
    this.loadAppResources(this.onInitSuccess)
  },
  methods: {
    forceSplashClosed() {
      if (settings.availableFrontendUrls().length > 0) {
        this.onInitSuccess()
      }
    },
    onInitSuccess() {
      this.initialized = true
      this.$emit('configurationLoaded')
    },
    beforeEnter(el) {
      el.style.opacity = 0
    },
    enter(el, done) {
      Velocity(
          el,
          {
            opacity: 1,
            scale: '1.3'
          },
          {
            duration: 2000,
            easing: 'easeOutCubic'
          }
      )
      Velocity(
          el,
          {
            opacity: 0,
            scale: 1
          },
          {
            duration: 2000,
            easing: 'easeInCubic',
            complete: () => {
              if (!this.initialized) {
                this.enter(el, done)
              }
            }
          }
      )
    }
  }
}
</script>
